'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import { JPY } from 'self-service-api/constants/CurrencyCodes'; // Helpful for currencies with large denominations (i.e. COP)

const ABBREVIATE_THRESHOLD = 100000; // We start to abbreviate Japanese Yen at higher threshold
// to avoid seeing 万 (10,000) symbol https://issues.hubspotcentral.com/browse/WBZ-623

const JPY_ABBREVIATE_THRESHOLD = 99999999;
const MAX_FRACTION_DIGITS = 3;

const PriceDisplay = (_ref) => {
  let {
    className,
    currencyCode,
    price,
    dataSelenium = '',
    round = true
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "currencyCode", "price", "dataSelenium", "round"]);

  const abbreviateThreshold = currencyCode === JPY ? JPY_ABBREVIATE_THRESHOLD : ABBREVIATE_THRESHOLD;
  return /*#__PURE__*/_jsx("span", Object.assign({
    className: className,
    "data-selenium-id": dataSelenium
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedCurrency, {
      simplifyCurrency: true,
      value: round ? Math.round(price) : price,
      currencyCode: currencyCode,
      abbreviate: true,
      abbreviateThreshold: abbreviateThreshold,
      maxFractionDigits: MAX_FRACTION_DIGITS
    })
  }));
};

PriceDisplay.propTypes = {
  dataSelenium: PropTypes.string,
  className: PropTypes.string,
  currencyCode: PropTypes.string.isRequired,
  price: PropTypes.number,
  round: PropTypes.bool
};
export default PriceDisplay;